import { FormProvider } from 'react-hook-form';
import { Box, Fade } from '@mui/material';
import { LoadingBackdrop } from '../../../components/_components';
import loginbg from '../../../assets/images/new-background.png';
import { useLoginPage } from '../hooks/useLoginPage';
import { LoginHero } from '../components/LoginHero';
import { LoginForm } from '../components/LoginForm';
import { ActiveSessionModal } from '../components/ActiveSessionModal';

export default function LoginPage() {
  const {
    isMobile,
    form,
    loading,
    showActiveSessionModal,
    login,
    googleSignIn,
    handleForgotPasswordClick,
    handleConfirmActiveSessionLogin,
    dismissActiveSessionModal,
    dismissActiveSessionAndSignOut,
  } = useLoginPage();

  return (
    <>
      <LoadingBackdrop open={loading} />

      <Fade in>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: { xs: 'center', md: 'flex-start' },
            background: '#e7e7e7',
            backgroundImage: `url(${loginbg})`,
            backgroundPosition: 'left',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'auto 100%',
            width: '100%',
            minHeight: '100vh',
            padding: { xs: '8px 8px', sm: '0px 40px', md: '0px 0px' },
            boxSizing: 'border-box',
          }}
        >
          <LoginHero isMobile={isMobile} />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: { xs: '100%', sm: '80%', md: '55%' },
              minHeight: { md: '100vh' },
              paddingLeft: { xs: '0px', md: '30px' },
              paddingRight: { xs: '0px', md: '30px' },
              boxSizing: 'border-box',
            }}
          >
            <FormProvider {...form}>
              <LoginForm
                loading={loading}
                onLogin={(values) => void login(values)}
                onGoogleSignIn={() => void googleSignIn()}
                onForgotPasswordClick={() => void handleForgotPasswordClick()}
              />
            </FormProvider>
          </Box>
        </Box>
      </Fade>
      {showActiveSessionModal && (
        <ActiveSessionModal
          isOpen={showActiveSessionModal}
          isLoading={loading}
          onClose={dismissActiveSessionModal}
          onDismissAndSignOut={() => void dismissActiveSessionAndSignOut()}
          onConfirmLogin={handleConfirmActiveSessionLogin}
        />
      )}
    </>
  );
}
